import React, { useEffect, useState } from 'react';

import { Typography } from '@telus-uds/components-web';
import QuantityField from './quantityField';

import {
  ServiceWrapper,
  Table,
  Thead,
  Th,
} from './css';
import AddSVG from '../assets/svg/add';
import ServiceLabel from './serviceLabel';
import DeleteSVG from '../assets/svg/delete';

export default function Service({
  quantityData,
  offeringId,
  serviceIndex,
  setSavingData,
  managedDetectionResponseData,
  setManagedDetectionResponseData
}) {
  const {
    name: serviceLabel,
    id:serviceId,
    productCatalogQuantities,
  } = managedDetectionResponseData;

  return (
    <ServiceWrapper>
     
      <Table>
        <Thead>
          <Th width="40%">
            <ServiceLabel
              serviceLabel={serviceLabel}
              offeringId={offeringId}
              serviceIndex={serviceIndex}
              setSavingData={setSavingData}
              managedDetectionResponseData={managedDetectionResponseData}
              setManagedDetectionResponseData={setManagedDetectionResponseData}
            />
          </Th>
          <Th width="40%"></Th>
          <Th width="10%"><Typography>Cost</Typography></Th>
          <Th width="10%"><Typography>Price</Typography></Th>
        </Thead>
        <tbody>
          {serviceId && (
            <QuantityField
              serviceId={serviceId}
              quantityData={productCatalogQuantities[0] || quantityData}
              serviceIndex={serviceIndex}
              setSavingData={setSavingData}
              managedDetectionResponseData={managedDetectionResponseData}
              setManagedDetectionResponseData={setManagedDetectionResponseData}
            />
          )}
          
          
        </tbody>
      </Table>
    </ServiceWrapper>
  );
}
